import React from 'react';
import { Link } from 'react-router-dom';
import { Col, Container, Row } from 'reactstrap';
import { H2, H4 } from '../../../AbstractElements';
import { BACK_TO_HOME_PAGE, Maintanancetext1, Maintanancetext2, MAINTENANCE } from '../../../Constant';

import { MaintenanceSvg } from '../../../Data/Page/Svg';
const Maintenance = () => {
  return (
    <div className='page-wrapper'>
      <div className='error-wrapper maintenance-bg'>
        <Container>
          <Row>
            <Col xs='12'>
              <div className='svg-wrapper'>
                <MaintenanceSvg />
              </div>
            </Col>
            <div className='maintenance-heading'>
              <H2 className='headline'>{MAINTENANCE}</H2>
            </div>
            <H4 className='sub-content'>
              {Maintanancetext1}
              <br />
              {Maintanancetext2}
            </H4>
            <div>
              <Link to={`${process.env.PUBLIC_URL}/dashboard/default`} className='btn btn-primary text-light'>
                {BACK_TO_HOME_PAGE}
              </Link>
            </div>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default Maintenance;
